<template>
  <div class="cancel-progress" role="progressbar" :aria-valuenow="current + 1" :aria-valuemax="total">
    <span
      v-for="index in total"
      :key="index"
      class="cancel-progress__segment"
      :class="{ 'cancel-progress__segment--filled': index - 1 <= current }"
    ></span>
  </div>
</template>

<script setup lang="ts">
defineProps<{ current: number; total: number }>();
</script>

<style scoped lang="scss">
.cancel-progress {
  display: flex;
  gap: 6px;
  margin-bottom: 1.5rem;

  &__segment {
    flex: 1 1 0;
    height: 4px;
    border-radius: 999px;
    background-color: var(--gray-border, #434343);
    transition: background-color 0.25s ease-in-out;

    &--filled {
      background-color: var(--yellow, #ffd700);
    }
  }
}
</style>
